import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/app';
import { Providers } from './app/providers';
import { registerServiceWorker } from './lib/push';
// Side effect: catches Chrome's one-shot install prompt before React mounts.
import './lib/install';
import './app/globals.css';

// The installable shell and the notifications. Not awaited: the app renders
// without it, and on a first visit the worker is still installing anyway.
void registerServiceWorker();

const root = document.getElementById('root');
if (!root) throw new Error('No #root element — index.html is not the one that was served');

createRoot(root).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
